// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"808ef491","777":"36db604b"}[chunkId] + ".chunk.js";
};